/** Текст с `инлайн-кодом` в обратных кавычках (подсказки, ответы, ошибки). */
export function Inline({ text }: { text: string }) {
  const parts = text.split("`");
  // Нечётное число кавычек — последняя незакрыта, печатаем её как есть.
  if (parts.length % 2 === 0) return <>{text}</>;
  return (
    <>
      {parts.map((p, i) =>
        i % 2 === 1 ? (
          <code key={i} className="rounded-[3px] bg-bg2 px-1 py-px font-mono text-[0.92em] text-ink">
            {p}
          </code>
        ) : (
          p
        ),
      )}
    </>
  );
}
